export const useRelativeTime = () => {
	const currentTime = ref(new Date())
	const intervalId: Ref<NodeJS.Timeout | null> = ref(null)

	const timeDifference = (activityTime: Date) => {
		const difference = (currentTime.value.getTime() - activityTime.getTime()) / 1000 // Difference in seconds
		if (difference < 60) {
			return 'just now'
		} else if (difference < 3600) {
			const minutes = Math.floor(difference / 60)
			return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} ago`
		} else if (difference < 86400) {
			const hours = Math.floor(difference / 3600)
			return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`
		} else {
			const days = Math.floor(difference / 86400)
			return `${days} ${days === 1 ? 'day' : 'days'} ago`
		}
	}
	const updateTime = () => {
		currentTime.value = new Date()
	}

	onMounted(() => {
		intervalId.value = setInterval(updateTime, 60000)
	})

	onBeforeUnmount(() => {
		if (intervalId.value) {
			clearInterval(intervalId.value)
		}
	})

	return {
		timeDifference
	}
}
